import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { SponsorStudy } from '../../sponsor-dashboard/sponsor-study';
import { StudyBuildPart } from './study-build-part';

export class SponsorBuildPart extends BaseBuildPart {
    constructor(private readonly sponsorHelperParams: HelperParams,
                parent: BaseBuildPart) {
        super(sponsorHelperParams, parent, ['sponsor']);
    }

    public study(study: SponsorStudy): StudyBuildPart {
        return new StudyBuildPart(this.sponsorHelperParams, this, study);
    }
}